import React, { useState } from 'react';
import { storage } from '../firebase';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { getFirestore, collection, addDoc, Timestamp } from 'firebase/firestore';
import { useAuth } from './AuthContext';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

const db = getFirestore();

const BlogPostCMS = () => {
  const { user } = useAuth();
  const [name, setName] = useState('');
  const [headerImage, setHeaderImage] = useState(null);
  const [headerImageFile, setHeaderImageFile] = useState(null);
  const [content, setContent] = useState([{ type: 'text', value: '' }]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");

  if (!user) {
    return (
      <div className="max-w-md mx-auto p-8 bg-white rounded shadow text-center mt-8">
        <h2 className="text-2xl font-bold mb-4">CMS Login</h2>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            setLoginError("");
            try {
              await signInWithEmailAndPassword(auth, email, password);
            } catch (err) {
              setLoginError("Invalid credentials");
            }
          }}
          className="flex flex-col gap-4 items-center"
        >
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            className="px-3 py-2 border rounded w-full"
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            className="px-3 py-2 border rounded w-full"
            required
          />
          <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded">Sign In</button>
          {loginError && <div className="text-red-500">{loginError}</div>}
        </form>
      </div>
    );
  }

  const handleContentChange = (index, value) => {
    const newContent = [...content];
    newContent[index].value = value;
    setContent(newContent);
  };

  const addContentSection = () => {
    setContent([...content, { type: 'text', value: '' }]);
  };

  const removeContentSection = (index) => {
    if (content.length === 1) return;
    setContent(content.filter((_, i) => i !== index));
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setHeaderImageFile(e.target.files[0]);
      setHeaderImage(e.target.files[0].name);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);
    let imagePath = '';
    try {
      if (headerImageFile) {
        const imageRef = ref(storage, `blogHeaders/${Date.now()}_${headerImageFile.name}`);
        await uploadBytes(imageRef, headerImageFile);
        imagePath = imageRef.fullPath;
      }
      await addDoc(collection(db, 'updates'), {
        name,
        header_image: imagePath,
        content,
        created_on: Timestamp.now(),
      });
      setSuccess(true);
      setName('');
      setHeaderImage(null);
      setHeaderImageFile(null);
      setContent([{ type: 'text', value: '' }]);
    } catch (err) {
      setError('Failed to add blog post.');
    }
    setLoading(false);
  };

  return (
    <div className="max-w-2xl mx-auto p-8 bg-white rounded shadow">
      <h2 className="text-2xl font-bold mb-4">Add New Blog Post</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block mb-1 font-semibold">Title</label>
          <input
            type="text"
            className="w-full border px-3 py-2 rounded"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label className="block mb-1 font-semibold">Header Image</label>
          <input type="file" accept="image/*" onChange={handleImageChange} />
        </div>
        <div className="mb-4">
          <label className="block mb-1 font-semibold">Content Sections</label>
          {content.map((section, idx) => (
            <div key={idx} className="flex items-center mb-2">
              <textarea
                className="w-full border px-3 py-2 rounded"
                value={section.value}
                onChange={e => handleContentChange(idx, e.target.value)}
                required
                placeholder={`Section ${idx + 1}`}
              />
              <button
                type="button"
                className="ml-2 px-2 py-1 bg-red-500 text-white rounded"
                onClick={() => removeContentSection(idx)}
                disabled={content.length === 1}
              >
                Remove
              </button>
            </div>
          ))}
          <button
            type="button"
            className="mt-2 px-4 py-2 bg-blue-500 text-white rounded"
            onClick={addContentSection}
          >
            Add Section
          </button>
        </div>
        {error && <div className="text-red-500 mb-2">{error}</div>}
        {success && <div className="text-green-600 mb-2">Blog post added successfully!</div>}
        <button
          type="submit"
          className="bg-gray-900 text-white text-bold px-6 py-2 rounded font-bold"
          disabled={loading}
        >
          {loading ? 'Submitting...' : 'Submit'}
        </button>
      </form>
    </div>
  );
};

export default BlogPostCMS;

